module.exports = __webpack_public_path__ + "static/testimonials-1-dd12b880821af6f0ebacfa914a2c120b.png";